var map = {
	"./1.svg": 305,
	"./10.svg": 975,
	"./2.svg": 976,
	"./3.svg": 977,
	"./4.svg": 978,
	"./5.svg": 979,
	"./6.svg": 980,
	"./7.svg": 981,
	"./8.svg": 982,
	"./9.svg": 983,
	"./district.svg": 296,
	"./email.svg": 297,
	"./logo.svg": 58,
	"./province.svg": 295,
	"./score.svg": 299,
	"./web.svg": 298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 300;